import React, { useState } from 'react';
import { SwipeableCard } from '../components/common/SwipeableCard';
import toast from 'react-hot-toast';

/**
 * 스와이프 테스트 페이지
 */
const SwipeTestPage: React.FC = () => {
  const [cards, setCards] = useState([
    { id: 1, name: '김팀원', reason: '가족 행사', date: '2026-03-20' },
    { id: 2, name: '이팀원', reason: '병원 예약', date: '2026-03-21' },
    { id: 3, name: '박팀원', reason: '개인 일정', date: '2026-03-22' },
    { id: 4, name: '최팀원', reason: '휴식', date: '2026-03-23' },
  ]);

  const handleApprove = (id: number) => {
    const card = cards.find(c => c.id === id);
    toast.success(`${card?.name} 님의 휴무 신청을 승인했습니다!`);
    setCards(cards.filter(c => c.id !== id));
  };

  const handleReject = (id: number) => {
    const card = cards.find(c => c.id === id);
    toast.error(`${card?.name} 님의 휴무 신청을 거절했습니다.`);
    setCards(cards.filter(c => c.id !== id));
  };

  return (
    <main className="container mx-auto px-4 py-12 pb-0">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-primary mb-2">👆 스와이프 테스트</h1>
        <p className="text-gray-600 mb-8">카드를 좌우로 스와이프해보세요!</p>

        {/* 사용법 안내 */}
        <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 mb-6">
          <h3 className="font-bold text-blue-800 mb-2">📖 사용법</h3>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>• 오른쪽으로 스와이프 → ✅ 승인</li>
            <li>• 왼쪽으로 스와이프 → ❌ 거절</li>
            <li>• 카드를 손가락으로 밀어보세요!</li>
          </ul>
        </div>

        {/* 스와이프 카드 목록 */}
        {cards.length === 0 ? (
          <div className="text-center py-16 bg-gray-50 rounded-xl">
            <div className="text-6xl mb-4">🎉</div>
            <p className="text-lg text-gray-600">모든 신청을 처리했습니다!</p>
            <button
              onClick={() => setCards([
                { id: Date.now() + 1, name: '김팀원', reason: '가족 행사', date: '2026-03-20' },
                { id: Date.now() + 2, name: '이팀원', reason: '병원 예약', date: '2026-03-21' },
                { id: Date.now() + 3, name: '박팀원', reason: '개인 일정', date: '2026-03-22' },
                { id: Date.now() + 4, name: '최팀원', reason: '휴식', date: '2026-03-23' },
              ])}
              className="mt-4 btn-primary px-6 py-3 rounded-lg"
            >
              다시 시작
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {cards.map((card) => (
              <SwipeableCard
                key={card.id}
                onApprove={() => handleApprove(card.id)}
                onReject={() => handleReject(card.id)}
              >
                <div className="card-azocsii">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h3 className="text-lg font-bold text-primary">{card.name}</h3>
                      <p className="text-sm text-gray-600">{card.date}</p>
                    </div>
                    <div className="bg-orange-100 px-3 py-1 rounded-full">
                      <span className="text-xs font-medium text-orange-700">대기 중</span>
                    </div>
                  </div>
                  <p className="text-gray-700">
                    <span className="font-medium">사유:</span> {card.reason}
                  </p>
                </div>
              </SwipeableCard>
            ))}
          </div>
        )}

        {/* 일반 버튼 (스와이프 못 할 때) */}
        {cards.length > 0 && (
          <div className="mt-8 bg-gray-50 rounded-xl p-4">
            <p className="text-sm text-gray-600 mb-3">스와이프가 안 되면 버튼을 사용하세요:</p>
            <div className="flex gap-2">
              <button
                onClick={() => handleApprove(cards[0].id)}
                className="flex-1 bg-green-500 text-white py-3 rounded-lg font-bold"
              >
                ✅ 승인
              </button>
              <button
                onClick={() => handleReject(cards[0].id)}
                className="flex-1 bg-red-500 text-white py-3 rounded-lg font-bold"
              >
                ❌ 거절
              </button>
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default SwipeTestPage;
